import axiosInstance from "../../../../axiosInstance";
import { success, error, info } from "../../../../store/notification/actions";
import { AIMS_RESET_PASSWORD_URL } from "../../../constants/baseConstants";

export async function ValidateUserEmail(params) {
  try {
    info("Sending verification code ...");
    const response = await axiosInstance.post("/email/validateEmail", {
      user_email: params.user_email,
    });
    if (response.data && response.data.data.length && response.data.data[0].fn_verifyuseremail_forgotpass === 1) {
      SendForgotPasswordMail(params);
    } else {
      error("Invalid email address !!!");
      return false;
    }
  } catch (err) {
    error("Invalid email address !!!");
  }
}

export async function SendForgotPasswordMail(params) {
  try {
    info("Sending verification code ...");
    const response = await axiosInstance.post("/email/sendemail", {
      user_email: params.user_email,
      user_name: params.user_email,
      email_content: `\n Hi, \n Please click on the below link to reset password \n \n ${AIMS_RESET_PASSWORD_URL}/resetPassword?email=${params.user_email}`,
    });
    if (response) {
      success("Verification code sent successfully");
      if (!params.redirect) window.location.href = `/verificationCodeSent`;
      return true;
    } else {
      error("Error sending email !!!");
      return false;
    }
  } catch (err) {
    error("Error sending email !!!");
  }
}

// Reset password

export const SaveResetPassword = (data) => {
  info("Reseting password...");
  return axiosInstance
    .post("/user/resetPassword", {
      user_id: data.user_id,
      password: data.new_password,
    })
    .then((res) => {
      if (res.data.status === "success") {
        success("Password reset successfully !!!");
        window.location.href = `${AIMS_RESET_PASSWORD_URL}/passwordResetSuccess`;
        return { message: "", hasError: false, data: res.data.data };
      }
    })
    .catch((err) => {
      error(err.response.data.error[0].message);
      return {
        message: err.response.data.error[0].message,
        hasError: true,
        data: "",
      };
    });
};
